export const ADD_SYLLABUS = 'ADD_SYLLABUS'
export const GET_ALL_SYLLABUS = 'GET_ALL_SYLLABUS'
export const GET_ONE_SYLLABUS = 'GET_ONE_SYLLABUS'
export const DELETE_SINGLE_SYLLABUS = 'DELETE_SINGLE_SYLLABUS'
export const UPDATE_SYLLABUS = 'UPDATE_SYLLABUS'
export const GET_WEIGHTAGE_SYLLABUS = 'GET_WEIGHTAGE_SYLLABUS'
export const DELETE_SYLLABUS_RESOURCE = 'DELETE_SYLLABUS_RESOURCE'
export const DELETE_MANY_SYLLABUS = 'DELETE_MANY_SYLLABUS'
